import { Box, Flex, Heading, Stack } from '@chakra-ui/react';
interface ContractDetailsSectionProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
}
const ContractDataSection = ({
  children,
  title,
}: ContractDetailsSectionProps) => {
  if (typeof title == 'string') {
    title = <Heading variant="small">{title}</Heading>;
  }
  return (
    <Stack
      align="flex-start"
      padding="5"
      h="100%"
      bg="white"
      mb="4"
      borderRadius={8}
    >
      <Flex w="100%" mb="6" align="center" justify={'space-between'}>
        {title}
      </Flex>
      <Box w="100%">{children}</Box>
    </Stack>
  );
};
export default ContractDataSection;
